import { MemberShootingClearance } from '@api/manageMembersApi/interfaces';
import { WeaponGroup } from '@api/disciplinesApi/interfaces';
import { ShootingClearanceCategory } from '@api/shootingApi/interfaces';
import { resolveRequiredClearanceCategories } from '@helpers/clearanceCategories';

export const memberHasRequiredShootingClearance = (
  requiredWeaponGroups: WeaponGroup[],
  clearances: MemberShootingClearance[] | undefined,
  categoryByWeaponGroupCode: Map<WeaponGroup, ShootingClearanceCategory>
): boolean => {
  if (requiredWeaponGroups.length === 0) {
    return true;
  }

  const requiredCategories = resolveRequiredClearanceCategories(
    requiredWeaponGroups,
    categoryByWeaponGroupCode
  );

  if (requiredCategories.length === 0) {
    return true;
  }

  const memberCategories = (clearances ?? []).map(
    (clearance) => clearance.clearanceCategory
  );

  return requiredCategories.some((category) =>
    memberCategories.includes(category)
  );
};

export const filterWeaponGroupsMemberCanUse = (
  weaponGroups: WeaponGroup[],
  clearances: MemberShootingClearance[] | undefined,
  categoryByWeaponGroupCode: Map<WeaponGroup, ShootingClearanceCategory>
): WeaponGroup[] => {
  return weaponGroups.filter((weaponGroup) =>
    memberHasRequiredShootingClearance(
      [weaponGroup],
      clearances,
      categoryByWeaponGroupCode
    )
  );
};
